import { computed, observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { noop } from '@src/utils/common-util';

class TabMenuStore {
  @observable activeIndex = 0;

  @computed
  get activeTab() {
    return this.tabList[this.activeIndex];
  }

  onTabChange = noop;

  constructor(props) {
    Object.assign(this, props);
  }

  // { tab_title: '最新', tab_key: 'new' }[]
  @observable tabList = [];

  handleTabChange = (index, tabItem) => {
    this.activeIndex = index;
    this.onTabChange?.(index, tabItem);
  };

  use() {
    useMount(() => {});
  }
}

export default TabMenuStore;
